export const getSketchData = sketchName => {
  const sketchData = sketchName.split('_');

  return {
    view: sketchData[1],
    vendoCode: sketchData[2],
    matchCode: sketchData[3] ? sketchData[3] : '',
  };
};
